import { serverURL, getToken, getLocale } from './env';
var axios = require('axios');
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
var normalAxios = axios.create({
  baseURL: serverURL,
});

//添加一个请求拦截器
normalAxios.interceptors.request.use(function (config) {
  //在请求发送之前做一些事
  /*
  var token = getToken(); //window.localStorage.getItem('token') || '';
  var locale = getLocale();//语言环境
  if (token && token != 'undefined') {
    config.headers.common.token = token;
  }
  config.headers.common.locale = locale;
  */
  return config;
}, function (error) {
  //当出现请求错误是做一些事
  return Promise.reject(error);
});

//添加一个返回拦截器
normalAxios.interceptors.response.use(function (response) {
  //api 调用出错的标志result=false;
  if (!response.data.result) {
    //对返回的错误进行一些处理
    return Promise.reject({ message: response.data.message, result: false });
  }
  //升级为业务对象
  response.data = response.data.data || {};//兼容成功时没有数据情况
  return response;
}, function (error) {
  if (error.response && error.response.status == 401) {//因安全问题被拒绝
    //对返回的错误进行一些处理
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('profile');
    window.localStorage.removeItem('lastMenuInfo');
    window.location.hash = "/";
    //return Promise.reject(error);
  }
  else {
    //对返回的错误进行一些处理
    return Promise.reject({ message: "网络故障，请检查网络!", result: false });
  }
});

export default normalAxios;
